import { instance } from "./apiClient";

export const savingsSourcesApi = {
  getSavingsSources: () =>
    instance.get("/api/savings_sources").then((res) => res.data),

  getSavingsSource: (sourceId) =>
    instance.get(`/api/savings_sources/${sourceId}`).then((res) => res.data),

  updateSavingsSource: ({ sourceId, payload }) =>
    instance
      .put(`/api/savings_sources/${sourceId}`, payload)
      .then((res) => res.data),

  createSavingsSource: (payload) =>
    instance.post("/api/savings_sources", payload).then((res) => res.data),

  deleteSavingsSource: (sourceId) =>
    instance.delete(`/api/savings_sources/${sourceId}`).then((res) => res.data),

  getSavingsSourceChartData: (sourceId) =>
    instance
      .get(`/api/savings_sources/${sourceId}/chart_data`)
      .then((res) => res.data),

  createSavingsSourceAsset: ({ sourceId, kind, payload }) => {
    const resource = kind === "stocks" ? "stocks" : "crypto_assets";

    return instance
      .post(`/api/savings_sources/${sourceId}/${resource}`, payload)
      .then((res) => res.data);
  },

  updateSavingsSourceAsset: ({ sourceId, id, kind, payload }) => {
    const resource = kind === "stocks" ? "stocks" : "crypto_assets";

    return instance
      .put(`/api/savings_sources/${sourceId}/${resource}/${id}`, payload)
      .then((res) => res.data);
  },

  deleteSavingsSourceAsset: ({ sourceId, id, kind }) => {
    const resource = kind === "stocks" ? "stocks" : "crypto_assets";

    return instance
      .delete(`/api/savings_sources/${sourceId}/${resource}/${id}`)
      .then((res) => res.data);
  },
};
